import { useForm } from 'react-hook-form';
import styles from './FilterList.module.scss';
import { Button, CheckBoxOption, RolePermissionChecker, Text } from 'components';
import { appActions } from 'store/app/slice';
import { selectDashboardFilter } from 'store/dashboard/selectors';
import { dashboardActions } from 'store/dashboard/slice';
import { getClinics, getDoctors } from 'store/users/selectors';
import { useDispatch, useSelector } from 'store/utils';
import { UserRole } from 'types';
import { parseFormDataToRequestParams } from 'utils';

type Props = {
  onClose?: () => void;
};

export const FilterList = ({ onClose }: Props) => {
  const dispatch = useDispatch();

  const dashboardFilter = useSelector(selectDashboardFilter);
  const clinics = useSelector(getClinics);
  const doctors = useSelector(getDoctors);

  const { register, handleSubmit } = useForm({
    defaultValues: {
      clinics: dashboardFilter.clinicIds,
      doctors: dashboardFilter.doctorIds,
    },
  });

  const onSubmit = handleSubmit(async (formData) => {
    const requestParams = parseFormDataToRequestParams(formData);
    dispatch(dashboardActions.setDashboardFilter(requestParams));
    if (onClose) {
      onClose();
    } else {
      dispatch(appActions.setIsModalOpened({ name: 'dashboardFilter', isOpened: false }));
    }
  });

  return (
    <form className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.blocks}>
          <RolePermissionChecker rolesAllowedToView={[UserRole.ADMIN, UserRole.DOCTOR, UserRole.READ_ONLY]}>
            <div className={styles.block}>
              <Text type="overline" className={styles.blockTitle}>
                Studios
              </Text>
              <div className={styles.optionsList}>
                {clinics.map((el) => (
                  <CheckBoxOption optionText={el.name} key={el.id} id={el.id} register={register('clinics')} />
                ))}
              </div>
            </div>
          </RolePermissionChecker>
          <RolePermissionChecker rolesAllowedToView={[UserRole.ADMIN, UserRole.CLINIC, UserRole.READ_ONLY]}>
            <div className={styles.block}>
              <Text type="overline" className={styles.blockTitle}>
                Doctors
              </Text>
              <div className={styles.optionsList}>
                {doctors.map((el) => (
                  <CheckBoxOption optionText={el.name} key={el.id} id={el.id} register={register('doctors')} />
                ))}
              </div>
            </div>
          </RolePermissionChecker>
        </div>
        <div className={styles.buttonWrapper}>
          <Button className={styles.button} onClick={onSubmit}>
            Save filters
          </Button>
        </div>
      </div>
    </form>
  );
};
